import { AskResponse } from "../api";

const seccions: string[] = ["B2B", "B2C", "O2", "eSimFlag"];

const scopes_B2B: string[] = ["Empresas PE", "Empresas ME", "Empresas GGCC", "MiGeDi"];

const scopes_B2B_Migedi: string[] = ["Empresas PE", "Empresas ME", "Empresas GGCC", "MiGeDi"];

const scopes_B2C: string[] = [
    "Canal presencial",
    "Canal telefónico",
    "CGR",
    "Isla",
    "RetenGenerica",
    "RetenPortados",
    "PostReten",
    "CAOL",
    "WhatsApp",
    "Soporte al punto de venta",
    "1P SAT",
    "Seguro hogar"
];

const scopes_B2C_Telco: string[] = [
    "Canal presencial",
    "Canal telefónico",
    "CGR",
    "Isla",
    "RetenGenerica",
    "RetenPortados",
    "PostReten",
    "CAOL",
    "WhatsApp",
    "Soporte al punto de venta",
    "1P SAT",
    "Seguro hogar",
    "O2"
];

const scopes_O2 = ["O2"];

const scopeValuesQuestionInput_O2 = ["O2", "CRC_O2"];

const scopes_eSimFlag = ["eSimFlag"];

const scopeValuesQuestionInput_eSimFlag = ["CRC_TELCO_O2_ESIMFLAG"];

//const seccions_B2C: string[] = ["Canal telefónico", "Canal presencial", "Retención", "CGR", "Isla", "CAOL", "CATSA","Seguro Hogar Canal Telefónico","Seguro Hogar Tiendas","WhatsApp"];
const seccions_B2CB2B: string[] = [
    "Canal pesencial",
    "Canal telefónico",
    "CGR",
    "Isla",
    "RetenGenerica",
    "RetenPortados",
    "PostReten",
    "CAOL",
    "WhatsApp",
    "Soporte al punto de venta",
    "1P SAT",
    "Seguro hogar",
    "Empresas PE",
    "Empresas ME",
    "Empresas GGCC",
    "O2"
];
//const seccions_B2CB2B: string[] = ["Canal telefónico", "Canal presencial", "Retención", "CGR", "Isla", "CAOL", "CATSA","Seguro Hogar Canal Telefónico","Seguro Hogar Tiendas","WhatsApp", "Empresas PE", "Empresas ME", "Empresas GGCC", "O2"];

const scopeValuesQuestionInput = [
    "Root",
    "Contributors_Residencial",
    "Contributors_Residencial_Ext",
    "Contributors_Telco",
    "ContentManagers",
    "ContentManagersExt",
    "CRC_RESIDENCIAL",
    "CRC_TELCO",
    "CONSL",
    "CRC_ATENCION_EMPLEADO",
    "ESREK",
    "CRC_SEGURO_HOGAR_INT",
    "CRC_SOPORTE_INTEGRAL_PV",
    "CRC_CATSA",
    "CRC_SEGURO_HOGAR_EXT",
    "Canal telefónico",
    "Canal presencial",
    "Retención",
    "CGR",
    "Isla",
    "CAOL",
    "WhatsApp",
    "RetenGenerica",
    "RetenPortados",
    "PostReten",
    "Soporte al punto de venta",
    "1P SAT",
    "Seguro hogar"
];

const scopeValuesQuestionInput_Telco = [
    "Root",
    "Contributors_Residencial",
    "Contributors_Residencial_Ext",
    "Contributors_Telco",
    "ContentManagers",
    "ContentManagersExt",
    "CRC_RESIDENCIAL",
    "CRC_TELCO",
    "CONSL",
    "CRC_ATENCION_EMPLEADO",
    "ESREK",
    "CRC_SEGURO_HOGAR_INT",
    "CRC_SOPORTE_INTEGRAL_PV",
    "CRC_CATSA",
    "CRC_SEGURO_HOGAR_EXT",
    "Canal telefónico",
    "Canal presencial",
    "Retención",
    "CGR",
    "Isla",
    "CAOL",
    "WhatsApp",
    "RetenGenerica",
    "RetenPortados",
    "PostReten",
    "Soporte al punto de venta",
    "1P SAT",
    "Seguro hogar",
    "O2",
    "CRC_TELCO_O2_ESIMFLAG"
];
const hagstagValuesQuestionInput = {
    "Modos Generalistas": ["#CT", "#CP"],
    "Modos Retención": ["#RetenGenerica", "#RetenPortados", "#PostReten"],
    "Modos Especiales COL": ["#AOL", "#FormulariosCOL", "#LeadsCOL", "#WhatsApp"],
    "CP SAV": ["#SAV"],
    "O2-1551": ["#O2"],
    "Modos Especiales 1004": [ "#AtencionNocturna", "#Bocsoporte", "#CambioDireccion", "#CancelacionPortabilidad", "#CAOL", "#CGR", "#CIAC","#ClientesEnLegado", "#CNSE", "#EspecialistaCobros", "#EspecialistaFARO", "#EspecialistaSolar360","#Insatisfechos", "#ModeloMQCTG", "#OTP", "#Repos", "#SeguimientoPortabilidad", "#ServiciosDigitales", "#Taskforce", "#Verificacionportabilidad", "#WFdesistimiento"],
    "1002": ["#1002"],
};

const mockAnswers: [user: string, response: AskResponse][] = [
    [
        "Comparativa promocion Movistar Car y Alarma Movistar Prosegur",
        {
            answer: "Pues Movistar plus mola más, esto es una respuesta fake, debido a que ahora el mismo el servicio de chat está caído, y blablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablabla",
            links: [
                { id: "694471", sectionid: "", title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471", sectionid: "12342",title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                { id: "694471", sectionid: "", title: "Tarifas movistar plus", vigencia_dates: "27-09-2023 a 31-10-2024", vigente: "false" }
            ],
            azs_links: [
                { id: "694471", sectionid: "694471",title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471", sectionid: "694471",title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                { id: "694471", sectionid: "694471",title: "Tarifas movistar plus", vigencia_dates: "27-09-2023 a 31-10-2024", vigente: "false" }
            ],
            scope: "blabla",
            negocio:"blabla",
            acceso:"blabla",
            centro:"blabla",
            docType:"blabla",
            thoughts: "blabla",
            data_points: ["blabla", "blabla"],
            debug_data: "blabla",
        }
    ],
    [
        "¿Cuál es la tarifa por defecto para contratos de residencial?",
        {
            answer: "Pues Movistar plus mola más, esto es una respuesta fake, debido a que ahora el mismo el servicio de chat está caído, y blablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablabla",
            links: [
                { id: "694471", sectionid: "694471",title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471", sectionid: "694471",title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                { id: "694471",sectionid: "694471", title: "Tarifas movistar plus", vigencia_dates: "27-09-2023 a 31-10-2024", vigente: "false" }
            ],
            azs_links: [
                { id: "694471", sectionid: "694471",title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471",sectionid: "", title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                { id: "694471",sectionid: "694471", title: "Tarifas movistar plus", vigencia_dates: "27-09-2023 a 31-10-2024", vigente: "false" }
            ],
            scope:"blabla",
            negocio:"blabla",
            acceso:"blabla",
            centro:"blabla",
            docType:"blabla",
            thoughts: "blabla",
            data_points: ["blabla", "blabla"],
            debug_data: "blabla"
        }
    ],
    [
        "¿Cómo se puede solicitar a Logística la anulación de un pedido?",
        {
            answer: "Pues Movistar plus mola más, esto es una respuesta fake, debido a que ahora el mismo el servicio de chat está caído, y blablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablablabla",
            links: [
                { id: "694471", sectionid: "694471",title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471", sectionid: "694471",title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                {
                    id: "694471",
                    sectionid: "694471",
                    title: "Tarifas movistar plusTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datoTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datossTarifas voz y datosTarifas voz y datos",
                    vigencia_dates: "27-09-2023 a 31-10-2024",
                    vigente: "false"
                }
            ],
            azs_links: [
                { id: "694471", sectionid: "694471",title: "Tarifas voz y datos", vigencia_dates: "04-05-2023 a 06-08-2024", vigente: "true" },
                { id: "694471",sectionid: "694471", title: "Tarifas voz", vigencia_dates: "01-02-2023 a 14-11-2024", vigente: "true" },
                {
                    id: "694471",
                    sectionid: "694471",
                    title: "Tarifas movistar plusTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datoTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datosTarifas voz y datossTarifas voz y datosTarifas voz y datos",
                    vigencia_dates: "27-09-2023 a 31-10-2024",
                    vigente: "false"
                }
            ],
            scope:"blabla",
            negocio:"blabla",
            acceso:"blabla",
            centro:"blabla",
            docType:"blabla",
            thoughts: "blabla",
            data_points: ["blabla", "blabla"],
            debug_data: "blabla"
        }
    ]
];

export { seccions, scopes_B2B, scopes_B2B_Migedi, scopes_B2C, scopes_B2C_Telco, scopes_O2, scopes_eSimFlag,seccions_B2CB2B, scopeValuesQuestionInput, scopeValuesQuestionInput_Telco, hagstagValuesQuestionInput, mockAnswers, scopeValuesQuestionInput_O2, scopeValuesQuestionInput_eSimFlag};